var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyCrypto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 11.3332C29.3333 16.1198 25.4533 19.9998 20.6667 19.9998C20.44 19.9998 20.2 19.9865 19.9733 19.9732C19.64 15.7465 16.2533 12.3598 12.0267 12.0265C12.0133 11.7998 12 11.5598 12 11.3332C12 6.5465 15.88 2.6665 20.6667 2.6665C25.4533 2.6665 29.3333 6.5465 29.3333 11.3332Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9998 20.6667C19.9998 25.4533 16.1198 29.3333 11.3332 29.3333C6.5465 29.3333 2.6665 25.4533 2.6665 20.6667C2.6665 15.88 6.5465 12 11.3332 12C11.5598 12 11.7998 12.0133 12.0265 12.0267C16.2532 12.36 19.6399 15.7467 19.9732 19.9733C19.9865 20.2 19.9998 20.44 19.9998 20.6667Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.16 19.4935L11.3333 17.3335L12.5067 19.4935L14.6667 20.6668L12.5067 21.8402L11.3333 24.0002L10.16 21.8402L8 20.6668L10.16 19.4935Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCrypto);
export default __webpack_public_path__ + "static/media/buy-crypto.a4e2440633b61b561f46a5857f34413a.svg";
export { ForwardRef as ReactComponent };